import $ from 'jquery';
// import TweenMax from "gsap";
import 'slick-carousel';
import { loadQuizAll } from "./quiz";

let gaSet = false;
$(function() {
  shuffleContent($(".modal_dialog_sliderWrap"));
  if ($("body").hasClass("quizmode")) {
    // SPECIAL画像をセット
    $(".modal_dialog_sliderWrap").slick(
      {
        prevArrow: '<img src="../img/icon_slide_r.png" class="slide-arrow prev-arrow">',
        nextArrow: '<img src="../img/icon_slide_l.png" class="slide-arrow next-arrow">'
      }
    );
    if ( $("body").data("no") == "01" ){
      loadQuizAll(1);
    }else{
      loadQuizAll(5);
    }

    if (typeof ga == 'function') {
      //本番環境用GAトラッカー作成
      ga('create', 'UA-6624382-1', 'auto');
      gaSet = true;
    }
  }
});

$('.switchGA').click(function() {
  var setData = $(this).data("ga");
  if (typeof ga == 'function') {
    if(!gaSet){
      ga('create', 'UA-6624382-1', 'auto');
      gaSet = true;
    }
    ga('send', 'event', 'nogizaka46ja', 'クイズ', setData);
  }
});

$('.modal_dialog_close, .modal_bg').click(function() {
  $(".modal, .modal_dialog").fadeOut(300, function() {
  });
});
$('.openModal').click(function() {
  var no = $(this).data("no");
  $(".modal_dialog_slot_inner, .modal_dialog_slider").removeClass("active");
  if (99 == no || 98 == no) {
    shuffleContent($(".modal_dialog_slot_inner"));
    shuffleContent($(".modal_dialog_sliderWrap"));
  }
  $(".modal").fadeIn(300, function() {

    $(".modal_dialog[data-no='" + no + "']").fadeIn(300);
    if (99 == no || 98 == no) {
      setTimeout(function() {
        $(".modal_dialog_slot_inner").addClass("active");
      }, 100);
      $('.modal_dialog_sliderWrap').slick('slickNext');

      setTimeout(function() {
        $(".modal_dialog_slider").addClass("active");
      }, 700);

    }
  });
});
var nT = 0;
$('.modal_dialog_btn').click(function() {
  // shuffleContent($(".modal_dialog_slot_inner"));
  // $(".modal_dialog_slot_inner").removeClass("active");
  // setTimeout(function() {
  //   $(".modal_dialog_slot_inner").addClass("active");
  // }, 100);

  var content = $(".modal_dialog_slot_inner").find("> *");
  var total = content.length;

  // content.each(function() {
  //   content.eq(Math.floor(Math.random() * total)).prependTo(container);
  // });

});

$(window).on("scroll", function() {
  scrollAnime();
});
$(window).on("resize", function() {
  edit();
  scrollAnime();
});
$(window).on("load", function() {
  edit();
  if ($("body").hasClass("top")) {
    var video = <HTMLVideoElement>document.getElementById('video');
    var movie_url = "video/bg.mp4";
    var windowWidth = $(window).innerWidth();

    if (windowWidth < 750) {
      movie_url = "video/bg_sp.mp4";
    }

    video.src = movie_url;
    video.load();
    video.play();
  }
  $(".loading").fadeOut(600, function() {
    $(".container").css("opacity", "1");
    scrollAnime();
  });
});
function edit() {
  var windowWidth = $(window).innerWidth();

  if (windowWidth >= 750) {
    // $(".mv").height(window.innerHeight + "px");
  }
}
$(".share_link").on("click", function() {

  let URL = "https://www.asahi.com/ads/nogizaka46ja2020/";
  let TITLE = "乃木坂46、JAグループ特設ウェブサイト「国消国産」を考える | 朝日新聞デジタル";
  let TYPE = $(this).data("type");

  if ($(this).data("page")) {
    URL = URL + $(this).data("page");
    TITLE = $("title").first().text();
  }

  // SNS type
  console.log(TYPE)
  switch (TYPE) {
    case "tw":
      URL = "https://twitter.com/intent/tweet?text=" + encodeURIComponent(TITLE) + "&url=" + URL;
      break;
    case "fb":
      URL = "https://www.facebook.com/sharer/sharer.php?u=" + URL;
      break;
    case "line":
      URL = "https://social-plugins.line.me/lineit/share?url=" + URL;
      break;
    default:
  }

  window.open(URL, TYPE, 'width=550, height=450, personalbar=0, toolbar=0, scrollbars=1, resizable=1');
});


$('a.scroller[href^="#"]').on("click", function() {
  var target = $($(this).attr("href"));
  var position = target.offset().top;

  $('body,html').stop().animate({
    scrollTop: position
  }, 500);
  return false;
});

function scrollAnime() {
  var windowHeight = $(window).innerHeight(),
    windowWidth = $(window).innerWidth(),
    topWindow = $(document).scrollTop(),
    docHeight = $(document).innerHeight(),
    fadeH = 200
    ;

  if(topWindow > docHeight-windowHeight-500){
      $('.floating').fadeOut(300);
  }else{
      $('.floating').fadeIn(300);
  }

  $('.fadein, .fadein2').each(function() {
    var targetPosition = $(this).offset().top;

    if(  $(this).is(':hidden') ){
      return;
    }

    fadeH = $(this).data("fadeheight") != undefined ? $(this).data("fadeheight") : 200;

    if (topWindow > targetPosition - windowHeight + (fadeH)) {
      $(this).addClass($(this).data("fadein"));
    } else if ($(this).data("first") == "1") {
      $(this).addClass($(this).data("fadein"));
    }
  });
}
function shuffleContent(container) {
  var content = container.find("> *");
  var total = content.length;
  content.each(function() {
    content.eq(Math.floor(Math.random() * total)).prependTo(container);
  });
}